<div class="wrapper">
  <input matInput preventSpace (blur)="blur()" (keyup)="keyup()" (keyup.enter)="keyup()" (input)="change()"
    [disabled]="disabled" [(ngModel)]="value" [type]="PasswordType" [placeholder]="placeholder" />
  <div class="suffix icon__password__wrapper">
    <mat-icon (mouseup)="hidePassword()" (mousedown)="showPassword()" style="color: #9DA4AE" class="icon__password"> {{ PasswordIcon }}
    </mat-icon>
  </div>
</div>
<!-- <div class="hint">
    <span>Must contains numbers, alphabets and special characters</span>
</div> -->
